import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=a10a81e4&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=ts"
export * from "./StarRating.vue?vue&type=script&lang=ts"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=a10a81e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10a81e4",
  null
  
)

export default component.exports